export default __webpack_public_path__ + "static/media/playing.da01529c.webp";